import React, {Component} from 'react';

// todo same struture as acms admin? Content definition keys?
import WidgetDefault from "./WidgetDefault";
import LearnerWidget from "./LearnerWidget";
import EmailAdministrationWidget from "./EmailAdministrationWidget"
// import Config from "../../../core/config";

class WidgetLoader extends Component {

    UNSAFE_componentWillMount() {
        require('../../../frontend/styles/Widgets.scss');
    }

    render() {
        const { content: {contentDefinitionKey}} = this.props;

        switch (contentDefinitionKey) {
            case "InfoBlock":
                return (
                    <WidgetDefault {...this.props} />
                );
            case "LearnersHomeOverwrite":
                return (
                    <LearnerWidget {...this.props} />
                );
            case "EmailAdministrationWidget":
                return (
                    <EmailAdministrationWidget {...this.props} />
                );
            default:
                return (
                    <WidgetDefault {...this.props} />
                );
        }
    }
}

// const mapStateToProps = (state) => {
//     return {
//         version: state.layout.version,
//     };
// };
//
// const mapDispatchToProps = (dispatch) => {
//     return {
//         setVersion: () => dispatch(setVersion()),
//     };
// };

//Widget = connect(mapStateToProps, mapDispatchToProps)(FrontLayout)

export default WidgetLoader;



// WEBPACK FOOTER //
// ./src/widgets/components/Widgets/WidgetLoader.js